import { apiPost } from "../../api";

// Issuing an invoice (Draft -> Final, shown as "Issued") only gives it its
// number. It reaches QuickBooks when someone presses this button, once the
// invoice is Sent -- see invoicing.views.InvoiceViewSet.sync_to_qbo, which
// enforces the same rules and the "Can finalise invoices" permission.
export const SYNC_LABEL = "Sync to QuickBooks";

const SYNCABLE_STATUSES = ["SENT", "PAID"];
// A failed push may be retried. Pending means a push is already in flight;
// synced/conflict mean it is already in QuickBooks.
const RETRYABLE_STATES = ["not_synced", "failed"];

export function canSyncToQbo(inv) {
  if (!inv) return false;
  if (!SYNCABLE_STATUSES.includes((inv.status || "").toUpperCase())) return false;
  if (inv.qbo_id || inv.do_not_sync) return false;
  return RETRYABLE_STATES.includes(inv.sync_state || "not_synced");
}

// What to tell the user about an invoice's sync, or null if nothing is wrong.
export function syncProblem(inv) {
  const state = inv?.sync_state;
  if (state === "failed") {
    return `QuickBooks rejected this invoice: ${inv.sync_error || "no reason given"}`;
  }
  if (state === "conflict") {
    return `In QuickBooks, but flagged as a conflict: ${inv.sync_error || "the two copies differ"}`;
  }
  if (state === "pending_verification") {
    return "QuickBooks did not confirm the push. ClientZone is verifying it; check back in a few minutes.";
  }
  return null;
}

export const syncInvoiceToQbo = (id) => apiPost(`/api/invoices/${id}/sync_to_qbo/`, {});
